<template>
  <v-menu
    v-model="dialog"
    :close-on-content-click="false"
    :nudge-width="180"
    :nudge-bottom="5"
    offset-y
  >
    <v-btn dark small
      slot="activator"
      color="indigo"
      >
      <v-icon>add</v-icon>Add new entity
    </v-btn>
    <v-card class="add_to_bookmark_menu">
    <v-list>
      <v-list-tile style="margin-bottom: 17px;">
        <v-text-field
          v-model="entityName"
          placeholder="Enter a name"
          :rules="[rules.required, rules.counter]"
          counter
          maxlength="255"
          ref="focus" />
      </v-list-tile>
      <v-list-tile class="mt-4">
        <v-select
          :items="allWikiEntityTypes"
          item-value="entity_type_id"
          item-text="entity_type_name"
          v-model.number="entityTypeId"
          label="Entity Type"
        ></v-select>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-action >
          <v-btn style="margin-right: 15px; padding-left: 10px; padding-right: 10px;" class="white--text" color="indigo"
          :disabled="!entityName || loading"
          @click="createEntity()">Create</v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import ALL_CURRENT_WIKI_ENTITIES from '@/graphql/Wiki/AllCurrentWikiEntities.gql'
import ALL_WIKI_ENTITY_TYPES from '@/graphql/Wiki/AllWikiEntityTypes.gql'
import CREATE_WIKI_CHANGE_REQUEST from '@/graphql/Wiki/CreateWikiChangeRequest.gql'

export default {
  name: 'CreateEntity',
  data () {
    return {
      dialog: false,
      entityName: '',
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 255 || 'Max 255 characters'
      },
      allWikiEntityTypes: [],
      entityTypeId: false,
      loading: false
    }
  },
  computed: {
    ...mapState('wiki', ['entityId'])
  },
  watch: {
    dialog (val) {
      if (!val) return
      setTimeout(() => {
        this.$refs.focus.focus()
      }, 100)
    }
  },
  methods: {
    ...mapMutations(['addError']),
    ...mapMutations('wiki', ['setEntityId', 'setViewedEntityDialog']),
    createEntity () {
      this.loading = true
      let changeRequestFields = [{
        target_field: 'entity_name',
        new_value_text: this.entityName
      }]
      if (this.entityTypeId) {
        changeRequestFields.push({
          target_field: 'entity_type_id',
          new_value_fk: this.entityTypeId
        })
      }

      this.$apollo.mutate({
        mutation: CREATE_WIKI_CHANGE_REQUEST,
        variables: {
          WikiChangeRequestInput: {
            target_type: 'wiki_entity',
            request_type: 'create',
            ChangeRequestFields: changeRequestFields
          }
        },
        update: (store, { data: { createWikiChangeRequest } }) => {
          // readquery creashes if allCurrentWikiEntities doesn't exist yet.
          try {
            const data = store.readQuery({ query: ALL_CURRENT_WIKI_ENTITIES })
            data.allCurrentWikiEntities.push(...createWikiChangeRequest)
            store.writeQuery({ query: ALL_CURRENT_WIKI_ENTITIES, data })
          } catch {}
        }
      }).then((resultObject) => {
        this.dialog = false
        this.loading = false
        this.entityName = ''
        this.entityTypeId = false
        this.setEntityId(resultObject.data.createWikiChangeRequest[0].entity_id)
        this.setViewedEntityDialog(true)
      }).catch((error) => {
        this.loading = false
        if (error.networkError.statusCode === 401) {
          this.$auth0.login()
        } else {
          this.addError(error)
        }
      })
    }
  },
  apollo: {
    allWikiEntityTypes: {
      query: ALL_WIKI_ENTITY_TYPES
    }
  }
}
</script>
<style>

</style>
